import React from 'react';

const Needle: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M43.87 6.424C22.471 9.406 6 27.78 6 50c0 24.3 19.7 44 44 44s44-19.7 44-44S74.3 6 50 6h-.004V0A49.992 49.992 0 01100 49.992 50.004 50.004 0 0130.862 96.19 49.99 49.99 0 01.004 49.992 49.293 49.293 0 0143.034.478l.836 5.946z"
    ></path>
    <path
      fill="currentColor"
      d="M69.645 35.643l-5.289-5.29a1.215 1.215 0 00-1.719 1.718l.96.96-3.681 3.682 3.37 3.374 3.681-3.68.959.959a1.217 1.217 0 001.719-1.723zm-7.035 5.965l-4.222-4.222-3.18-3.179a1.215 1.215 0 10-1.717 1.718l1 1-.417.417-.047.045-16.388 16.39a3.09 3.09 0 00-.111 4.24l-.705.704a1.87 1.87 0 000 2.644l.392.392-7 7a.73.73 0 001.032 1.031l7-7 .39.392a1.872 1.872 0 002.646 0l.704-.705a3.087 3.087 0 004.238-.111L62.61 45.976l.463-.463 1 1a1.216 1.216 0 001.72-1.719l-3.183-3.186zm-1.253 2.18l-.467.465-1.433 1.435-1.29 1.288-.468.47-13.196 13.197a.657.657 0 01-.926 0l-4.223-4.222a.655.655 0 010-.926l15.59-15.585 1.267-1.267 5.146 5.144z"
    ></path>
    <path
      fill="currentColor"
      d="M40.834 56.602a.921.921 0 01-1.297 0l4.038 4.04a.657.657 0 00.927 0l1.483-1.483-2.29-2.294a.846.846 0 011.193-1.196l2.291 2.292 2.47-2.47-2.289-2.293a.847.847 0 011.195-1.194l2.291 2.29 2.469-2.47-2.288-2.292a.847.847 0 011.195-1.195l2.29 2.291 1.946-1.946-3.853-3.855-11.771 11.775z"
    ></path>
  </svg>
);

export default Needle;
